module.exports = __webpack_public_path__ + "static/img/Bitmap.74f91c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Bitmap.png
// module id = j2BA
// module chunks = 1